'use client';
import React from 'react';
import {useParams} from 'next/navigation';
import Image from 'next/image';
import {ImageObj} from '@custom-types/ImageObj.types';
import {Box} from '@mui/material';

interface WildsLaunchLogoProps {
  logoImage: {ar: ImageObj; en: ImageObj};
}
export default function WaldorfLogo(props: WildsLaunchLogoProps) {
  const {lang} = useParams();
  const logoImage = lang === 'ar' ? props.logoImage.ar : props.logoImage.en;
  return (
    <Image
      layout='responsive'
      width={600}
      height={400}
      unoptimized
      quality={100}
      alt={logoImage?.url}
      src={logoImage?.url}
      style={{
        minWidth: '100%',
        height: 'auto !important',
        objectFit: 'cover',
      }}
    />
  );
}
